// components/NavDropdown.tsx
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowDown } from 'lucide-react';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuGroup,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '../../components/ui/dropdown-menu';

interface DropdownItem {
  label: string;
  path?: string;
  onClick?: () => void;
}

interface NavDropdownProps {
  triggerLabel: string;
  items: DropdownItem[];
  isShrunk: boolean;
  className?: string;
}

const NavDropdown: React.FC<NavDropdownProps> = ({ 
  triggerLabel, 
  items, 
  isShrunk, 
  className = "" 
}) => {
  const navigate = useNavigate();

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <button 
          className={`cursor-pointer flex items-center gap-1 md:gap-2 bg-transparent border-none ${className}`}
          aria-label={triggerLabel}
        >
          <span className={`font-medium text-sm md:text-[15px] flex flex-row items-center gap-1
            ${isShrunk ? "text-black" : "text-white"}`}>
            {triggerLabel}
            <ArrowDown size={16} color={isShrunk ? "black" : "white"} />
          </span>
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent className="w-56">
        <DropdownMenuGroup>
          {items.map((item, index) => (
            <DropdownMenuItem 
              key={index}
              onClick={() => {
                if (item.onClick) {
                  item.onClick();
                } else if (item.path) {
                  navigate(item.path);
                }
              }}
            >
              <span className="text-sm">{item.label}</span>
            </DropdownMenuItem>
          ))}
        </DropdownMenuGroup>
      </DropdownMenuContent>
    </DropdownMenu>
  );
};

export default NavDropdown;